import { css as _css } from "@emotion/core";
var _excluded = ["shadow"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import * as styles from './hero-text.style';
import { RotatingText } from '../rotating-text';
import { jsx as ___EmotionJSX } from "@emotion/core";
export var Subtitle = _ref => {
  var _ref$config = _ref.config,
    _ref$config$shadow = _ref$config.shadow,
    shadow = _ref$config$shadow === void 0 ? false : _ref$config$shadow,
    config = _objectWithoutProperties(_ref$config, _excluded),
    seed = _ref.seed,
    className = _ref.className;
  return ___EmotionJSX("h1", {
    className: className,
    css: /*#__PURE__*/_css([styles.subTitle, shadow && styles.shadow])
  }, ___EmotionJSX(RotatingText, _extends({}, config, {
    seed: seed
  })));
};